module.exports = __webpack_public_path__ + "static/salin.d366bb46.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project-img/salin.png
// module id = 270
// module chunks = 35783957827783